export const ISSUE = 'issue';
export const FIELD = 'field';

export type Key = typeof ISSUE | typeof FIELD;

export type State = {
	[key in Key]: {
		index?: number;
		isIndexLocked: boolean;
		timeoutId?: NodeJS.Timeout;
	};
};
